module.exports = __webpack_public_path__ + "img/0Q3A2361_L_Foamcore_MockedUp.5d473d66.jpg";